export class AuthService {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }

  async getToken(username, password) {
    try {
      const token = await this.axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/auth/login`,
        {
          username: `${username}`,
          password: `${password}`
        }
      );
      return token.data.access_token;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }
}
